import { usePathname } from "next/navigation";
import LinkedInLogo from "@components/layout/footerIconLogos/LinkedInLogo";

const LinkedInButton = () => {
  const pathname = usePathname();
  const basePath = process.env.NEXT_PUBLIC_SITE_URL;

  return (
    <>
      <a
        className="social-share-button linkedin-button"
        href={`https://www.linkedin.com/sharing/share-offsite/?url=${basePath}${pathname}`}
        target="_blank"
        aria-label="Share on LinkedIn"
      >
        <LinkedInLogo />
      </a>
      <style jsx>
        {`
          .linkedin-button :global(svg) {
            height: 18px;
            width: 18px;
          }
        `}
      </style>
    </>
  );
};

export default LinkedInButton;
